import React, { useCallback, useEffect, useMemo, useState } from "react";
import { linksAdmin, linksAdminNotSuper } from "../../../data/adminLinks";
import { linksLawyer } from "../../../data/lawyerLinks";
import { linksAccountant } from "../../../data/accountantLinks";
import { FaBuilding, FaUser } from "react-icons/fa";
import { GET_ENTERPRISE_BY_USER } from "../../../api/apiEmpresas";
import AccesoDirecto from "../../molecules/dashboard/AccesoDirecto";
import { useSession } from "../../../context/SessionContext";
import AnunciosDashBoard from "../Anuncios/AnunciosDashboard";
import { linksRH } from "../../../data/rhLinks";
import EmpresaListStats from "../empresaList/EmpresaListStats";
import { PropagateLoader } from "react-spinners";
import Fuse from "fuse.js";

const AccesosDirectos = ({ data, loading }) => {
    const { user } = useSession();
    const [empresas, setEmpresas] = useState();
    const [search, setSearch] = useState(""); 

    const getEnterprises = useCallback(async () => {
        try {
            const enterprisesData = await GET_ENTERPRISE_BY_USER(user?.id);
            setEmpresas(enterprisesData);
        } catch (error) {
            console.error(error);
        }
    } ,[user?.id]);

    useEffect(() => {
        if (user?.id && user?.role === "Client") {
            getEnterprises();
        }
    }, [user?.id, user?.role, getEnterprises]);

    const clientLinks = useMemo(() => {
        if (user?.role !== "Client") return [];

        const fuse = new Fuse(empresas || [], {
            keys: ["name"],
            threshold: 0.3,
        });

        const result = search ? fuse.search(search).map(r => r.item) : empresas;

        return result?.map((empresa) => ({
            path: `/clientes/empresas/${empresa?.id}`,
            label: empresa?.name,
            icon: empresa?.type === "LegalEntitie" ? FaBuilding : FaUser,
        }));
    }, [empresas, search, user?.role]);

    let links;

    if (user?.role === "Admin" && user?.roleInfo?.isSuperAdmin === true) {
        links = linksAdmin;
    } else if (user?.role === "Admin" && user?.roleInfo?.isSuperAdmin === false) {
        links = linksAdminNotSuper;
    } else if (user?.role === "Lawyer") {
        links = linksLawyer;
    } else if (user?.role === "Accountant") {
        links = linksAccountant;
    } else if (user?.role === "HumanResources") {
        links = linksRH;
    } else if (user?.role === "Client") {
        links = clientLinks;
    };

    return(
        <div className="flex flex-col space-y-4">
            <AnunciosDashBoard/>
            {loading ?
                    <div className="w-full h-auto flex justify-center items-center">
                        <PropagateLoader color="red"/>
                    </div>
                :
                (user?.role === "Admin" && user?.roleInfo?.isSuperAdmin === true &&
                    <EmpresaListStats data={data} loading={loading} />
                )
            }
            {user?.role === "Client" && (
                <input
                    type="text"
                    placeholder="Buscar empresa..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="border-2 border-gray-300 rounded p-2 w-full lg:w-1/2"
                />
            )}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    {links?.map((link, index)=>
                        <AccesoDirecto href={link.path} label={link.label} icon={link?.icon} key={index} />
                    )}
                </div>
        </div>
    );
};

export default AccesosDirectos;